import $ from "jquery";
import "jquery-match-height";
import Cookies from "js-cookie";

const catalogList = () => {
    if ($(".catalog__item").length) {
        //одинаковая высота карточек товаров
        $(".catalog__item .name").matchHeight();
        $(".catalog__item .prices").matchHeight();
    }

    //фильтр
    if ($(".filter").length) {
        //аккордеон глобальных блоков (БРЕНД, КАТЕГОРИИ, ПАРАМЕТРЫ)
        $(".js-block-filter-toggle").click(function () {
            $(this)
                .toggleClass("active")
                .closest(".filter__block")
                .find(".js-block-filter-content")
                .slideToggle();
        });

        //аккордеон внутренних списков
        $(".js-filter-toggle").click(function () {
            if ($(this).closest(".filter__block").hasClass("cats")) {
                $(this)
                    .toggleClass("active")
                    .next(".js-filter-content")
                    .slideToggle();
            } else {
                $(this)
                    .toggleClass("active")
                    .parent()
                    .next(".js-filter-content")
                    .slideToggle();
            }
        });

        // блокировка состояния фильтра
        $(".js-block-filter-lock").click(function () {
            if (
                $(this)
                    .closest(".filter__block.cats")
                    .find(".js-block-filter-content")
                    .is(":visible")
            ) {
                $(this).toggleClass("active");
                if ($(this).hasClass("active")) {
                    Cookies.set("filterCatsState", "open", 7);
                } else {
                    Cookies.remove("filterCatsState");
                }
            } else {
                $(this).removeClass("active");
                Cookies.remove("filterCatsState");
            }
        });

        // раскрытие активной ветки: уровни по очереди, без параллельных slideToggle
        const openFilterBranch = ($toggle, onDone) => {
            if (!$toggle.length) {
                if (onDone) onDone();
                return;
            }

            const $content = $toggle.next(".js-filter-content");
            $toggle.addClass("active");

            if ($content.is(":visible")) {
                if (onDone) onDone();
                return;
            }

            $content.slideDown(onDone);
        };

        $(".category__item").each(function () {
            const currentCat = $(this).find(".current");
            if (!currentCat.length) return;

            const subCategoryItem = currentCat.closest(".sub-category__item");
            let $nestedToggle = $();

            if (currentCat.closest(".sub-sub-category").length) {
                subCategoryItem.find("> a").addClass("current");
                $nestedToggle = subCategoryItem
                    .find("> a")
                    .next(".js-filter-toggle");
            } else if (subCategoryItem.length) {
                $nestedToggle = currentCat.next(".js-filter-toggle");
            }

            $(this).find("> a").addClass("current");

            openFilterBranch(
                $(this).find("> a").next(".js-filter-toggle"),
                () => openFilterBranch($nestedToggle)
            );
        });
    }

    if ($(".ajax-wrapper").length) {
        let isLoading = false;
        let shouldLoad = true;

        async function fetchItems(next) {
            let lastPageNumb = new URL(
                $(".pagination .pages li:last-child a").attr("href"),
                window.location.origin
            ).searchParams.get("page");

            let nextPageNumb = new URL(
                next,
                window.location.origin
            ).searchParams.get("page");

            let nextPage = next;

            if (isLoading || !shouldLoad) return;
            isLoading = true;

            await $.get(
                nextPage,
                function (response) {
                    let content = $(response).find(".ajax-wrapper");

                    $(".ajax-wrapper").append(content.children());

                    //одинаковая высота карточек товаров
                    $(".catalog__item .name").matchHeight();
                    $(".catalog__item .prices").matchHeight();
                },
                "html"
            );

            nextPageNumb++;

            let nextPageUrl = new URL(
                $(".pagination .arrows__item_next").attr("href"),
                window.location.origin
            );

            nextPageUrl.searchParams.set("page", `${nextPageNumb}`);

            console.log(nextPageUrl);

            $(".pagination .arrows__item_next").attr(
                "href",
                nextPageUrl.origin + nextPageUrl.pathname + nextPageUrl.search
            );

            if (nextPageNumb > lastPageNumb) shouldLoad = false;
            isLoading = false;
        }

        function throttle(callee, timeout) {
            let timer = null;

            return function perform(...args) {
                if (timer) return;

                timer = setTimeout(() => {
                    callee(...args);

                    clearTimeout(timer);
                    timer = null;
                }, timeout);
            };
        }

        async function checkPos() {
            if ($(".pagination .arrows__item_next").length) {
                let scrolled = $(window).scrollTop();
                let checkLine =
                    $(".ajax-wrapper").offset().top +
                    $(".ajax-wrapper").height();
                let position = scrolled + $(window).height();
                let nextPage = $(".pagination .arrows__item_next").attr("href");

                if (position >= checkLine) {
                    await fetchItems(nextPage);
                }
            }
        }
        // подргузка элментов на мобиле при скролле
        if ($(window).width() < 992) {
            $(window).on("scroll", throttle(checkPos));
        }
    }

    // фильтр параметров
    // :todo при изменении диапазона параметров перезагружать страницу (on.mouseup)
    // $("input.filter__range-item").change("input", function () {
    //     console.log(123);
    // });
};

export default catalogList;
